var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoostRocketEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7997 83.6865C16.114 90.172 24.8854 97.115 11.4282 106.544C11.4282 106.544 19.3425 109.201 26.514 100.172C28.9711 97.058 31.8282 95.772 31.8282 95.772C32.7997 96.3435 32.0568 99.515 28.5997 102.115C28.5997 102.115 33.9997 102.258 37.3711 98.8865C40.7425 95.515 43.0282 90.658 43.0282 90.658C45.3425 94.715 39.5425 99.858 39.5425 99.858C39.5425 99.858 44.9997 98.4295 51.4855 91.9435C56.514 86.915 60.114 74.372 52.8855 67.172C45.6568 59.972 32.7711 61.258 26.4568 67.6005C23.6854 70.372 20.8568 74.6865 20.4854 78.2295C20.4854 78.2295 25.7997 72.4865 27.6854 74.915C27.6854 74.915 18.6854 80.3435 17.2282 85.515C17.2568 85.515 21.7425 82.8295 22.7997 83.6865Z",
    fill: "url(#paint0_linear_2003_3033)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8288 88.6305C10.8288 91.4305 15.3431 97.316 12.3145 100.344C12.3145 100.344 16.3431 98.1445 16.2859 93.8305C16.2288 90.316 17.8288 88.6305 17.8288 88.6305Z",
    fill: "url(#paint1_linear_2003_3033)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4568 109.058C21.2568 108.858 24.2853 103.63 28.3996 104.487C28.3996 104.487 24.7139 109.858 19.4568 109.058Z",
    fill: "url(#paint2_linear_2003_3033)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M41.5997 98.572C43.7997 97.7435 47.5426 95.915 51.4855 91.9435C55.914 87.515 59.6 74.9435 52.3425 67.715C45.2569 60.6295 32.8283 62.058 26.8569 68.0295C24.714 70.172 22.4283 73.401 21.514 76.372C22.7997 75.2295 24.714 73.801 26.314 73.6295C27.1426 73.5435 27.7997 73.8295 28.2569 74.401L28.714 74.972L27.914 75.458C27.8283 75.515 20.8569 79.772 18.4855 84.115C20.114 83.2865 22.3426 82.372 23.2569 83.115L23.7712 83.5435L23.1712 84.1435C20.6855 86.572 20.5426 89.058 20.4283 91.9435C20.2283 96.0865 19.9997 100.744 12.9712 106.144C15.3712 106.458 20.8283 106.315 25.9997 99.8295C28.5712 96.572 31.5426 95.201 31.6569 95.1435L31.9997 95.001L32.2569 95.1435C32.7426 95.4295 32.9712 96.058 32.8855 96.8865C32.7712 98.0295 32.0283 99.658 30.4283 101.315C32.1997 101.087 34.9712 100.43 36.9426 98.458C40.1712 95.2295 42.3997 90.5435 42.4283 90.4865L43.0569 89.1435L43.6569 90.201C45.1997 92.9435 43.4854 96.2865 41.5997 98.572Z",
    fill: "url(#paint3_linear_2003_3033)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3145 100.344C14.2859 98.7445 16.3145 95.602 16.2859 93.8305C16.2573 92.202 16.7145 89.916 17.8288 88.6305C12.9145 90.716 13.6002 94.002 14.2288 95.6305C14.5145 96.3445 14.143 98.459 12.3145 100.344Z",
    fill: "url(#paint4_radial_2003_3033)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1145 105.173C25.4288 102.116 27.9145 91.5445 33.886 89.716C39.886 87.8875 38.3717 93.602 36.0574 96.202C36.0574 96.202 43.9717 88.259 44.0002 82.059C44.0574 75.859 52.3715 85.5445 49.8002 90.573C49.8002 90.573 62.5145 77.859 52.343 67.716C42.1717 57.573 28.6574 67.6875 28.6574 67.6875C28.6574 67.6875 36.3717 67.373 35.686 72.973C35.686 72.973 29.7431 75.2305 25.0574 78.973C25.0574 78.973 27.3431 79.2305 28.9145 81.573C28.9145 81.573 21.9145 86.402 22.2002 90.5445C22.6002 95.8875 19.1145 104.202 16.1145 105.173Z",
    fill: "url(#paint5_linear_2003_3033)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6282 97.1435C26.9711 96.0575 30.7996 85.886 36.9139 86.4575C40.2853 86.772 39.5139 89.686 39.5139 89.686C39.5139 89.686 41.8568 86.3435 42.3996 81.8575C42.9425 77.372 51.314 78.886 50.9425 87.3435C50.9425 87.3435 60.1425 75.372 48.9711 67.7435C36.6568 59.3435 27.6282 69.886 27.6282 69.886C27.6282 69.886 36.0568 67.086 37.3711 73.772C37.3711 73.772 30.3996 75.7145 27.8282 78.286C27.8282 78.286 30.7996 78.7145 31.5139 81.886C31.5139 81.886 24.6568 86.9145 24.8568 88.9145C25.3425 93.686 22.6282 97.1435 22.6282 97.1435Z",
    fill: "url(#paint6_linear_2003_3033)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.7997 83.6865C16.114 90.172 24.8854 97.115 11.4282 106.544C11.4282 106.544 19.3425 109.201 26.514 100.172C28.9711 97.058 31.8282 95.772 31.8282 95.772C32.7997 96.3435 32.0568 99.515 28.5997 102.115C28.5997 102.115 33.9997 102.258 37.3711 98.8865C40.7425 95.515 43.0282 90.658 43.0282 90.658C45.3425 94.715 39.5425 99.858 39.5425 99.858C39.5425 99.858 44.9997 98.4295 51.4855 91.9435C56.514 86.915 60.114 74.372 52.8855 67.172C45.6568 59.972 32.7711 61.258 26.4568 67.6005C23.6854 70.372 20.8568 74.6865 20.4854 78.2295C20.4854 78.2295 25.7997 72.4865 27.6854 74.915C27.6854 74.915 18.6854 80.3435 17.2282 85.515C17.2568 85.515 21.7425 82.8295 22.7997 83.6865Z",
    fill: "url(#paint7_radial_2003_3033)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.7997 83.6865C16.114 90.172 24.8854 97.115 11.4282 106.544C11.4282 106.544 19.3425 109.201 26.514 100.172C28.9711 97.058 31.8282 95.772 31.8282 95.772C32.7997 96.3435 32.0568 99.515 28.5997 102.115C28.5997 102.115 33.9997 102.258 37.3711 98.8865C40.7425 95.515 43.0282 90.658 43.0282 90.658C45.3425 94.715 39.5425 99.858 39.5425 99.858C39.5425 99.858 44.9997 98.4295 51.4855 91.9435C56.514 86.915 60.114 74.372 52.8855 67.172C45.6568 59.972 32.7711 61.258 26.4568 67.6005C23.6854 70.372 20.8568 74.6865 20.4854 78.2295C20.4854 78.2295 25.7997 72.4865 27.6854 74.915C27.6854 74.915 18.6854 80.3435 17.2282 85.515C17.2568 85.515 21.7425 82.8295 22.7997 83.6865Z",
    fill: "url(#paint8_radial_2003_3033)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1141 94.087C54.6285 87.144 58.314 74.744 51.514 67.944C44.7141 61.144 32.1998 66.8585 26.6569 71.9725C26.6569 71.9725 31.0855 70.1155 34.5712 72.344C38.0569 74.5725 28.0855 78.43 25.9998 84.544C25.9998 84.544 34.8855 79.201 37.6855 81.4585C40.4855 83.7155 37.6569 90.83 34.9712 93.5155C34.9712 93.5155 41.3426 90.2585 44.7712 86.0585C49.9998 79.63 48.1141 94.087 48.1141 94.087Z",
    fill: "url(#paint9_radial_2003_3033)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.7997 83.6865C16.114 90.172 24.8854 97.115 11.4282 106.544C11.4282 106.544 19.3425 109.201 26.514 100.172C28.9711 97.058 31.8282 95.772 31.8282 95.772C32.7997 96.3435 32.0568 99.515 28.5997 102.115C28.5997 102.115 33.9997 102.258 37.3711 98.8865C40.7425 95.515 43.0282 90.658 43.0282 90.658C45.3425 94.715 39.5425 99.858 39.5425 99.858C39.5425 99.858 44.9997 98.4295 51.4855 91.9435C56.514 86.915 60.114 74.372 52.8855 67.172C45.6568 59.972 32.7711 61.258 26.4568 67.6005C23.6854 70.372 20.8568 74.6865 20.4854 78.2295C20.4854 78.2295 25.7997 72.4865 27.6854 74.915C27.6854 74.915 18.6854 80.3435 17.2282 85.515C17.2568 85.515 21.7425 82.8295 22.7997 83.6865Z",
    fill: "url(#paint10_radial_2003_3033)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.8288 88.6305C10.8288 91.4305 15.3431 97.316 12.3145 100.344C12.3145 100.344 16.3431 98.1445 16.2859 93.8305C16.2288 90.316 17.8288 88.6305 17.8288 88.6305Z",
    fill: "url(#paint11_radial_2003_3033)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4568 109.056C21.2568 108.856 23.8853 105.17 28.3996 104.485C28.3996 104.485 24.7139 109.856 19.4568 109.056Z",
    fill: "url(#paint12_radial_2003_3033)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.4568 109.058C21.2568 108.858 24.2853 103.63 28.3996 104.487C28.3996 104.487 24.7139 109.858 19.4568 109.058Z",
    fill: "url(#paint13_radial_2003_3033)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.7997 83.6865C16.114 90.172 24.8854 97.115 11.4282 106.544C11.4282 106.544 19.3425 109.201 26.514 100.172C28.9711 97.058 31.8282 95.772 31.8282 95.772C32.7997 96.3435 32.0568 99.515 28.5997 102.115C28.5997 102.115 33.9997 102.258 37.3711 98.8865C40.7425 95.515 43.0282 90.658 43.0282 90.658C45.3425 94.715 39.5425 99.858 39.5425 99.858C39.5425 99.858 44.9997 98.4295 51.4855 91.9435C56.514 86.915 60.114 74.372 52.8855 67.172C45.6568 59.972 32.7711 61.258 26.4568 67.6005C23.6854 70.372 20.8568 74.6865 20.4854 78.2295C20.4854 78.2295 25.7997 72.4865 27.6854 74.915C27.6854 74.915 18.6854 80.3435 17.2282 85.515C17.2568 85.515 21.7425 82.8295 22.7997 83.6865Z",
    fill: "url(#paint14_radial_2003_3033)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M22.7997 83.6865C16.114 90.172 24.8854 97.115 11.4282 106.544C11.4282 106.544 19.3425 109.201 26.514 100.172C28.9711 97.058 31.8282 95.772 31.8282 95.772C32.7997 96.3435 32.0568 99.515 28.5997 102.115C28.5997 102.115 33.9997 102.258 37.3711 98.8865C40.7425 95.515 43.0282 90.658 43.0282 90.658C45.3425 94.715 39.5425 99.858 39.5425 99.858C39.5425 99.858 44.9997 98.4295 51.4855 91.9435C56.514 86.915 60.114 74.372 52.8855 67.172C45.6568 59.972 32.7711 61.258 26.4568 67.6005C23.6854 70.372 20.8568 74.6865 20.4854 78.2295C20.4854 78.2295 25.7997 72.4865 27.6854 74.915C27.6854 74.915 18.6854 80.3435 17.2282 85.515C17.2568 85.515 21.7425 82.8295 22.7997 83.6865Z",
    fill: "url(#paint15_radial_2003_3033)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M22.7997 83.6865C16.114 90.172 24.8854 97.115 11.4282 106.544C11.4282 106.544 19.3425 109.201 26.514 100.172C28.9711 97.058 31.8282 95.772 31.8282 95.772C32.7997 96.3435 32.0568 99.515 28.5997 102.115C28.5997 102.115 33.9997 102.258 37.3711 98.8865C40.7425 95.515 43.0282 90.658 43.0282 90.658C45.3425 94.715 39.5425 99.858 39.5425 99.858C39.5425 99.858 44.9997 98.4295 51.4855 91.9435C56.514 86.915 60.114 74.372 52.8855 67.172C45.6568 59.972 32.7711 61.258 26.4568 67.6005C23.6854 70.372 20.8568 74.6865 20.4854 78.2295C20.4854 78.2295 25.7997 72.4865 27.6854 74.915C27.6854 74.915 18.6854 80.3435 17.2282 85.515C17.2568 85.515 21.7425 82.8295 22.7997 83.6865Z",
    fill: "url(#paint16_radial_2003_3033)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7705 77.3155C76.113 70.9445 77.599 64.173 80.9705 58.0585L82.0275 56.1155L65.5415 66.887L64.1705 76.8015L57.7415 82.973C59.113 88.3445 59.1705 93.6015 59.1705 93.6015C70.113 87.0585 76.7705 77.3155 76.7705 77.3155Z",
    fill: "url(#paint17_linear_2003_3033)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1995 93.629C59.1995 93.629 59.171 88.3145 57.771 83.0005L60.4855 80.4005C61.314 82.229 62.9425 86.3435 63.3425 90.886C62.028 91.8005 60.6565 92.772 59.1995 93.629Z",
    fill: "url(#paint18_linear_2003_3033)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M76.7705 77.3155C76.113 70.9445 77.599 64.173 80.9705 58.0585L82.0275 56.1155L65.5415 66.887L64.1705 76.8015L57.7415 82.973C59.113 88.3445 59.1705 93.6015 59.1705 93.6015C70.113 87.0585 76.7705 77.3155 76.7705 77.3155Z",
    fill: "url(#paint19_radial_2003_3033)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3704 63.971C79.0564 61.971 79.9134 59.971 80.9704 58.0565L81.5704 56.971C81.4274 56.8855 81.2849 56.7995 81.1419 56.714L65.5704 66.914L64.6274 73.5995C68.1704 72.1425 73.1989 69.171 78.3704 63.971Z",
    fill: "url(#paint20_linear_2003_3033)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M60.485 39.1431C60.3135 38.7431 60.2275 38.4573 60.085 38.0859C53.942 41.0002 46.9991 41.8288 40.3134 40.5716C40.3134 40.5716 30.4277 47.0573 24.342 58.543C24.342 58.543 29.9992 59.086 35.942 61.1145L42.0277 54.5715L51.8565 54C54.0565 49.0573 56.7135 43.7716 60.485 39.1431Z",
    fill: "url(#paint21_linear_2003_3033)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.342 58.514C24.342 58.514 29.9992 59.057 35.942 61.0855L38.542 58.2855C36.4563 57.2 31.942 55.114 26.942 54.2285C26.0277 55.5715 25.142 57 24.342 58.514Z",
    fill: "url(#paint22_linear_2003_3033)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M60.485 39.1431C60.3135 38.7431 60.2275 38.4573 60.085 38.0859C53.942 41.0002 46.9991 41.8288 40.3134 40.5716C40.3134 40.5716 30.4277 47.0573 24.342 58.543C24.342 58.543 29.9992 59.086 35.942 61.1145L42.0277 54.5715L51.8565 54C54.0565 49.0573 56.7135 43.7716 60.485 39.1431Z",
    fill: "url(#paint23_radial_2003_3033)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0855 38.0566C57.6855 39.8852 50.1715 47.1423 47.5427 54.1995L51.8285 53.9425C54.0285 49.0566 57.3715 43.6566 61.1425 39.028L60.0855 38.0566Z",
    fill: "url(#paint24_linear_2003_3033)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6855 36.6591C65.2285 40.802 68.6 44.9163 72.3425 48.5734C72.514 48.7448 72.714 48.9163 72.8855 49.0877C76.057 52.116 79.4855 54.802 82.9715 56.945C83.2855 56.6305 83.6 56.345 83.914 56.0305C92.914 47.0306 98.1425 40.2591 102.629 31.6591C99.4285 25.4591 94.1715 20.202 87.9715 17.002C79.3715 21.4877 72.6285 26.6877 63.6 35.7163C63.2855 36.0306 62.9715 36.3448 62.6855 36.6591Z",
    fill: "url(#paint25_linear_2003_3033)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M102.599 31.6579C108.685 19.9722 107.914 13.6864 106.914 12.6864C105.914 11.6864 99.656 10.915 87.942 17.0007C94.142 20.2007 99.399 25.4579 102.599 31.6579Z",
    fill: "url(#paint26_linear_2003_3033)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.371 67.2575C55.6 70.4865 58.571 72.8575 59.371 72.8575C66.6285 69.6865 75.2855 64.372 82.9715 56.9435C79.514 54.8005 76.057 52.115 72.8855 49.0863C72.714 48.9149 72.514 48.7435 72.3425 48.572C68.6 44.9149 65.2285 40.8006 62.6855 36.6577C55.257 44.3435 49.9426 53.0575 46.7712 60.315C46.8855 61.2005 49.1998 64.115 52.371 67.2575Z",
    fill: "url(#paint27_linear_2003_3033)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M52.371 67.2575C55.6 70.4865 58.571 72.8575 59.371 72.8575C66.6285 69.6865 75.2855 64.372 82.9715 56.9435C79.514 54.8005 76.057 52.115 72.8855 49.0863C72.714 48.9149 72.514 48.7435 72.3425 48.572C68.6 44.9149 65.2285 40.8006 62.6855 36.6577C55.257 44.3435 49.9426 53.0575 46.7712 60.315C46.8855 61.2005 49.1998 64.115 52.371 67.2575Z",
    fill: "url(#paint28_radial_2003_3033)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M72.8855 49.0863C72.714 48.9149 72.514 48.7435 72.3425 48.572C68.6 44.9149 65.2285 40.8006 62.6855 36.6577C62.4855 36.8577 62.314 37.0577 62.1425 37.2577C67.3425 47.0863 83.2285 56.4575 71.114 61.4005C63.1715 64.6575 59.6 68.515 57.6855 71.9435C58.4855 72.5435 59.114 72.8575 59.4 72.8575C66.657 69.6865 75.314 64.372 83 56.9435C79.4855 54.8005 76.057 52.115 72.8855 49.0863Z",
    fill: "url(#paint29_radial_2003_3033)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3705 67.2579C49.2277 64.1149 46.9134 61.2004 46.7706 60.3149L42.3134 62.2864C41.7991 62.8004 44.7134 66.6004 48.8849 70.7434C53.0275 74.8864 56.8275 77.8289 57.342 77.3149L59.3705 72.8579C58.5705 72.8579 55.599 70.4864 52.3705 67.2579Z",
    fill: "url(#paint30_linear_2003_3033)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3705 67.2579C49.2277 64.1149 46.9134 61.2004 46.7706 60.3149L42.3134 62.2864C41.7991 62.8004 44.7134 66.6004 48.8849 70.7434C53.0275 74.8864 56.8275 77.8289 57.342 77.3149L59.3705 72.8579C58.5705 72.8579 55.599 70.4864 52.3705 67.2579Z",
    fill: "url(#paint31_linear_2003_3033)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M101.372 33.9448C101.429 33.8591 102.572 31.7448 102.6 31.6591C99.4 25.4591 94.1425 20.202 87.9425 17.002C87.857 17.0591 87.7715 17.0877 87.6855 17.1448C93.7715 20.602 100.657 28.3734 101.372 33.9448Z",
    fill: "url(#paint32_linear_2003_3033)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M106.915 12.6864C105.915 11.6864 99.6575 10.915 87.943 17.0007C79.343 21.4864 72.6005 26.6865 63.5715 35.715C63.2575 36.0293 62.9715 36.3436 62.6575 36.6579C55.229 44.3436 49.9146 53.058 46.7432 60.315C46.886 61.2005 49.2003 64.115 52.343 67.258C55.5715 70.4865 58.543 72.858 59.343 72.858C66.6005 69.6865 75.2575 64.372 82.943 56.9435C83.2575 56.6295 83.572 56.3435 83.886 56.0295C92.886 47.0293 98.1145 40.2579 102.601 31.6579C108.715 19.9722 107.943 13.6864 106.915 12.6864Z",
    fill: "url(#paint33_radial_2003_3033)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4566 81.831C55.0565 74.088 62.571 65.4595 62.771 65.231L61.285 63.745C61.285 63.745 53.4565 72.288 44.1138 80.488L45.4566 81.831Z",
    fill: "url(#paint34_linear_2003_3033)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2565 63.7445C62.9995 60.4305 65.942 56.259 69.7135 51.7735C69.628 51.6875 69.542 51.602 69.428 51.516C65.342 55.402 61.285 58.916 57.6565 62.002L53.428 68.202L47.0564 74.459C45.9421 77.259 44.0564 80.4875 44.0564 80.4875C53.428 72.2875 61.2565 63.7445 61.2565 63.7445Z",
    fill: "url(#paint35_linear_2003_3033)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3988 77.5155C47.3988 77.5155 49.6274 73.487 49.4274 72.173L47.0845 74.487C45.9702 77.287 44.0845 80.5155 44.0845 80.5155C45.2274 79.487 46.3131 78.487 47.3988 77.5155Z",
    fill: "url(#paint36_linear_2003_3033)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M62.771 65.232C64.028 61.4035 66.8565 57.118 70.485 52.4605C70.228 52.232 69.9995 52.0035 69.7425 51.775C65.971 56.2605 63.028 60.432 61.285 63.7465C61.285 63.7465 53.4565 72.289 44.1138 80.489L45.4852 81.832C55.171 74.0035 62.771 65.232 62.771 65.232Z",
    fill: "url(#paint37_linear_2003_3033)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4566 81.831C55.0565 74.088 62.571 65.4595 62.771 65.231L61.285 63.745C61.285 63.745 53.4565 72.288 44.1138 80.488L45.4566 81.831Z",
    fill: "url(#paint38_linear_2003_3033)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M61.2565 63.7445C62.9995 60.4305 65.942 56.259 69.7135 51.7735C69.628 51.6875 69.542 51.602 69.428 51.516C65.342 55.402 61.285 58.916 57.6565 62.002L53.428 68.202L47.0564 74.459C45.9421 77.259 44.0564 80.4875 44.0564 80.4875C53.428 72.2875 61.2565 63.7445 61.2565 63.7445Z",
    fill: "url(#paint39_radial_2003_3033)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M106.915 12.6864C105.915 11.6864 99.6575 10.915 87.943 17.0007C79.343 21.4864 72.6005 26.6865 63.5715 35.715C63.2575 36.0293 62.9715 36.3436 62.6575 36.6579C55.229 44.3436 49.9146 53.058 46.7432 60.315C46.886 61.2005 49.2003 64.115 52.343 67.258C55.5715 70.4865 58.543 72.858 59.343 72.858C66.6005 69.6865 75.2575 64.372 82.943 56.9435C83.2575 56.6295 83.572 56.3435 83.886 56.0295C92.886 47.0293 98.1145 40.2579 102.601 31.6579C108.715 19.9722 107.943 13.6864 106.915 12.6864Z",
    fill: "url(#paint40_radial_2003_3033)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M86.4855 53.458C82.714 51.2295 78.7995 48.2009 75.0855 44.5152C71.3995 40.8295 68.371 36.9152 66.1425 33.1152",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M97.6854 33.0884C98.5424 34.1455 99.3139 35.1741 100.057 36.2026",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M93.056 20.1733C92.6845 20.4305 92.313 20.7162 91.942 21.0019C84.456 26.6019 78.113 32.2305 69.113 41.2305C68.799 41.5448 68.4845 41.859 68.199 42.1733C67.913 42.4876 67.599 42.7733 67.313 43.0876",
    stroke: "black",
    strokeWidth: 16.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M82.5134 50.8595C90.4274 42.8024 95.4849 36.6881 100.256 29.3166C100.456 29.0309 100.627 28.7452 100.799 28.4595",
    stroke: "black",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M57.3425 70.8285C63.914 67 72.057 61.1145 79.6855 53.657L57.3425 70.8285Z",
    fill: "url(#paint41_radial_2003_3033)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M86.799 37.4294C83.142 40.8008 77.7135 40.8294 74.6845 37.4865C71.656 34.1436 72.199 28.6865 75.856 25.3151C79.5135 21.9436 84.942 21.9151 87.9705 25.2579C90.999 28.6008 90.456 34.0579 86.799 37.4294Z",
    fill: "url(#paint42_linear_2003_3033)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2275 35.5429C82.2275 38.3143 77.7705 38.3429 75.285 35.6C72.799 32.8571 73.2275 28.3714 76.256 25.6C79.2565 22.8286 83.7135 22.8 86.199 25.5429C88.6565 28.2857 88.2275 32.7714 85.2275 35.5429Z",
    fill: "url(#paint43_linear_2003_3033)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5135 34.8009C81.8275 37.2866 77.856 37.2866 75.656 34.858C73.456 32.4009 73.8275 28.4294 76.513 25.9437C79.199 23.458 83.1705 23.458 85.3705 25.8866C87.5705 28.3152 87.199 32.3151 84.5135 34.8009Z",
    fill: "url(#paint44_radial_2003_3033)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M84.5135 34.8009C81.8275 37.2866 77.856 37.2866 75.656 34.858C73.456 32.4009 73.8275 28.4294 76.513 25.9437C79.199 23.458 83.1705 23.458 85.3705 25.8866C87.5705 28.3152 87.199 32.3151 84.5135 34.8009Z",
    fill: "url(#paint45_radial_2003_3033)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M84.856 27.7162C85.856 28.8305 86.399 30.2305 86.513 31.6877C87.1415 29.6591 86.799 27.4591 85.3705 25.8877C83.1705 23.4305 79.199 23.4591 76.513 25.9448C76.256 26.202 75.999 26.4591 75.7705 26.7448C78.8275 24.8877 82.599 25.2305 84.856 27.7162Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3705 25.8877C83.1705 23.4305 79.199 23.4591 76.513 25.9448C73.8275 28.4305 73.456 32.4019 75.656 34.8591C75.8845 35.1162 76.113 35.2877 75.9705 35.1734C73.999 33.2019 74.599 29.1448 77.142 26.6019C79.199 24.5448 83.142 23.802 85.3705 25.8877Z",
    fill: "url(#paint46_linear_2003_3033)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M85.371 25.8866C83.1425 23.7723 79.171 24.5437 77.1425 26.5723C74.714 29.0009 74.057 32.8294 75.714 34.8866C75.971 35.0294 76.0855 35.2866 75.9425 35.1723C75.857 35.0866 75.771 35.0009 75.714 34.8866C75.6855 34.8866 75.657 34.858 75.628 34.858C77.828 37.3152 81.7995 37.2866 84.4855 34.8009C87.1995 32.3152 87.5995 28.3437 85.371 25.8866Z",
    fill: "url(#paint47_radial_2003_3033)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M102.657 31.572C99.4565 25.372 94.2565 20.1434 88.0565 16.9434",
    stroke: "#008EE6",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9715 56.9435C79.514 54.8005 76.057 52.115 72.8855 49.0863C72.714 48.9149 72.514 48.7435 72.3425 48.572C68.6 44.9149 65.2285 40.8006 62.6855 36.6577",
    stroke: "#008EE6",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2003_3033",
    x1: 51.2945,
    y1: 63.435,
    x2: 5.79831,
    y2: 123.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2317,
    stopColor: "#FF1500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7367,
    stopColor: "#FF3D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#FF4C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2003_3033",
    x1: 42.5559,
    y1: 57.7845,
    x2: -2.3919,
    y2: 117.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2317,
    stopColor: "#FF1500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7367,
    stopColor: "#FF3D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#FF4C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2003_3033",
    x1: 55.391,
    y1: 65.2504,
    x2: 9.28384,
    y2: 126.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2317,
    stopColor: "#FF1500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7367,
    stopColor: "#FF3D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#FF4C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2003_3033",
    x1: 42.2803,
    y1: 72.8515,
    x2: 12.981,
    y2: 133.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#FF5B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#FF4C00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.435991 104.711) rotate(-135) scale(23.6303 30.0067)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#FFED1C",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#FFED1C",
    stopOpacity: 0.0264782
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#FFED1C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2003_3033",
    x1: 18.5206,
    y1: 109.112,
    x2: 44.9601,
    y2: 71.2005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.022669,
    stopColor: "#FE7F02",
    stopOpacity: 0.9773
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6663,
    stopColor: "#ED582A",
    stopOpacity: 0.3337
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74939",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2003_3033",
    x1: 48.8965,
    y1: 69.899,
    x2: 24.9869,
    y2: 91.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1869,
    stopColor: "#FFB137",
    stopOpacity: 0.8131
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7223,
    stopColor: "#FF940F",
    stopOpacity: 0.2777
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8900",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.8248 76.245) rotate(-135) scale(18.2794 18.8415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#FFBC47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2941,
    stopColor: "#FFBF4B",
    stopOpacity: 0.7068
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5624,
    stopColor: "#FEC656",
    stopOpacity: 0.4382
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8201,
    stopColor: "#FCD368",
    stopOpacity: 0.1801
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBE07A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.1502 76.92) rotate(-135) scale(17.7161 18.2609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7115 79.345) rotate(-135) scale(21.763 32.1802)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#FFED1C",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#FFED1C",
    stopOpacity: 0.0264782
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#FFED1C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.4189 76.7755) rotate(-42.7273) scale(8.73275 5.58645)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.712 100.981) rotate(-135) scale(7.80725 9.91394)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#FFED1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#FFEE2B",
    stopOpacity: 0.8013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5839,
    stopColor: "#FFF254",
    stopOpacity: 0.4167
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF686",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3074 106.619) rotate(162.598) scale(7.5504 1.52773)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#FFED1C",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#FFED1C",
    stopOpacity: 0.0264782
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#FFED1C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9613 110.16) rotate(-41.019) scale(7.2065 2.28964)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#FFED1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#FFEE2B",
    stopOpacity: 0.8013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5839,
    stopColor: "#FFF254",
    stopOpacity: 0.4167
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF686",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.0386 103.107) rotate(-135) scale(24.361 30.9345)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#FF5B0C",
    stopOpacity: 0.8661
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3941,
    stopColor: "#FF842C",
    stopOpacity: 0.6067
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7491,
    stopColor: "#FFC45F",
    stopOpacity: 0.2512
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF686",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.9252 77.5505) rotate(-135) scale(12.9304 16.4196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#FFED1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#FFEE2B",
    stopOpacity: 0.8013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5839,
    stopColor: "#FFF254",
    stopOpacity: 0.4167
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF686",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.1375 78.1465) rotate(-135) scale(27.0391 34.3353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#FFED1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#FFEE2B",
    stopOpacity: 0.8013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5839,
    stopColor: "#FFF254",
    stopOpacity: 0.4167
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF686",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2003_3033",
    x1: 49.0186,
    y1: 96.321,
    x2: 78.32,
    y2: 64.7215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD2719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#D41A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5049,
    stopColor: "#EC0C07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#FA0302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2003_3033",
    x1: 66.0545,
    y1: 81.5145,
    x2: 56.862,
    y2: 90.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0900324,
    stopColor: "#FC7837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#FD4D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#FE2C14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6802,
    stopColor: "#FF1409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#FF0502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.7923 92.3305) rotate(45) scale(39.6421)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#FFED1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#FFEE2B",
    stopOpacity: 0.8013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5839,
    stopColor: "#FFF254",
    stopOpacity: 0.4167
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF686",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2003_3033",
    x1: 66.7399,
    y1: 71.501,
    x2: 112.155,
    y2: 18.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD2719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#D41A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5049,
    stopColor: "#EC0C07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#FA0302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2003_3033",
    x1: 20.8292,
    y1: 59.639,
    x2: 48.5002,
    y2: 46.0589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD2719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#D41A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5049,
    stopColor: "#EC0C07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#FA0302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2003_3033",
    x1: 36.6254,
    y1: 51.6215,
    x2: 27.9252,
    y2: 61.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0900324,
    stopColor: "#FC7837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#FD4D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#FE2C14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6802,
    stopColor: "#FF1409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#FF0502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.8529 76.5705) rotate(45) scale(42.639)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#FFED1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#FFEE2B",
    stopOpacity: 0.8013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5839,
    stopColor: "#FFF254",
    stopOpacity: 0.4167
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF686",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2003_3033",
    x1: 59.0945,
    y1: 45.8857,
    x2: 14.4671,
    y2: 47.9726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD2719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#D41A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5049,
    stopColor: "#EC0C07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#FA0302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2003_3033",
    x1: 75.2405,
    y1: 26.7547,
    x2: 93.2,
    y2: 44.7142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3717,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2003_3033",
    x1: 105.683,
    y1: 25.5381,
    x2: 95.9055,
    y2: 12.8496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#80DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7325,
    stopColor: "#76D5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8071,
    stopColor: "#5CC8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9026,
    stopColor: "#32B2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2003_3033",
    x1: 71.283,
    y1: 65.6405,
    x2: 50.8735,
    y2: 45.3404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#80DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7325,
    stopColor: "#76D5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8071,
    stopColor: "#5CC8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9026,
    stopColor: "#32B2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4275 72.372) rotate(45) scale(19.4199 35.544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.059 67.797) rotate(45) scale(19.4199 35.5441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2003_3033",
    x1: 44.853,
    y1: 60.1419,
    x2: 57.6545,
    y2: 76.9509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1962,
    stopColor: "#4D4D4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2003_3033",
    x1: 44.853,
    y1: 60.1419,
    x2: 57.6545,
    y2: 76.9509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1975,
    stopColor: "#CFDCDE",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2003_3033",
    x1: 71.6665,
    y1: 20.2246,
    x2: 101.023,
    y2: 26.9276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3717,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFB3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.38 57.004) rotate(44.2342) scale(12.5298 40.5754)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#440063",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#420061",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2003_3033",
    x1: 43.3037,
    y1: 79.2825,
    x2: 77.0375,
    y2: 57.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD2719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#D41A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5049,
    stopColor: "#EC0C07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#FA0302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2003_3033",
    x1: 37.8237,
    y1: 80.429,
    x2: 55.222,
    y2: 67.1825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD2719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#D41A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5049,
    stopColor: "#EC0C07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#FA0302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2003_3033",
    x1: 54.373,
    y1: 69.2775,
    x2: 44.4142,
    y2: 78.5795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0900324,
    stopColor: "#FC7837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#FD4D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#FE2C14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6802,
    stopColor: "#FF1409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#FF0502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2003_3033",
    x1: 54.047,
    y1: 75.7255,
    x2: 65.849,
    y2: 41.9518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD2719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#D41A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5049,
    stopColor: "#EC0C07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#FA0302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2003_3033",
    x1: 43.3037,
    y1: 79.2825,
    x2: 77.0375,
    y2: 57.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD2719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#D41A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5049,
    stopColor: "#EC0C07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#FA0302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.0119 76.326) rotate(-39.0499) scale(29.8762 10.0187)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00134333,
    stopColor: "#FFED1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1997,
    stopColor: "#FFEE2B",
    stopOpacity: 0.8013
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5839,
    stopColor: "#FFF254",
    stopOpacity: 0.4167
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF686",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.713 36.5745) rotate(44.2342) scale(12.5298 40.5754)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.936 65.2415) rotate(43.8644) scale(3.04225 14.6077)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#440063",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#420061",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2003_3033",
    x1: 76.596,
    y1: 41.5567,
    x2: 86.0165,
    y2: 21.2703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD2719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2151,
    stopColor: "#D41A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5049,
    stopColor: "#EC0C07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774,
    stopColor: "#FA0302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2003_3033",
    x1: 83.3105,
    y1: 22.0152,
    x2: 78.1805,
    y2: 39.0461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8D41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0900324,
    stopColor: "#FC7837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#FD4D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#FE2C14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6802,
    stopColor: "#FF1409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#FF0502"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.1035 30.6366) rotate(44.996) scale(16.5682 16.5671)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#512D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.329 27.3568) scale(14.5358 14.5357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4873,
    stopColor: "#F5CBC0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67E62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2003_3033",
    x1: 79.983,
    y1: 25.3137,
    x2: 80.602,
    y2: 14.3253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD2719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0422031,
    stopColor: "#B42717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#89250F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4654,
    stopColor: "#682408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6634,
    stopColor: "#502304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8464,
    stopColor: "#412201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_2003_3033",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.823 23.7972) scale(19.7109 19.7109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostRocketEmail);
export default __webpack_public_path__ + "static/media/boost-rocket-email.89b22de82c3f6a57e6c37b3e0edd51ef.svg";
export { ForwardRef as ReactComponent };